import { useCallback, useRef, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGetOneLiveDetailPeopleByUserId } from '../../../hooks/queries/lives/lives/use-get-one-live-detail-people-by-user-id'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { LiveGiftsAnimations } from '../../../types/lives/animations'

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'
// o backend manda 1 msg por destinatário; cada seat recebe todas mas só soma o
// SEU ponto. Sem agregar, cada seat atualiza quando a SUA msg chega (1 a 1).
// Com o debounce, todas as seats aplicam o setPoints ~na mesma hora (janela
// compartilhada) → os valores sobem TODOS ao mesmo tempo.
const BATCH_MS = 400

export function useUpdateUserLivePoints() {
  const [points, setPoints] = useState(0)

  const liveId = useGlobalStore(useShallow((state) => state.liveId))
  const liveUserId = useGlobalStore(useShallow((state) => state.liveUserId))

  const { oneDetailPeople } = useGetOneLiveDetailPeopleByUserId(
    liveUserId as number,
  )

  const batch = useRef<{ delta: number; timer: ReturnType<typeof setTimeout> | null }>(
    { delta: 0, timer: null },
  )

  const setPointsUserLive = useCallback(
    ({ message }: LiveGiftsAnimations) => {
      const usersReturns = message?.returnForUser?.flatMap(
        ({ returnForUser }) => returnForUser,
      )
      const mine = usersReturns?.find((item) => item.userId === liveUserId)

      // acumula o meu ganho nesta leva; reseta o timer em TODA msg da leva (mesmo
      // as que não são pra mim) → o disparo fica sincronizado entre as seats.
      batch.current.delta += mine?.value || 0
      if (batch.current.timer) clearTimeout(batch.current.timer)
      batch.current.timer = setTimeout(() => {
        const d = batch.current.delta
        batch.current = { delta: 0, timer: null }
        if (d) {
          setPoints((prev) => prev + d)
        }
      }, BATCH_MS)
    },
    [liveUserId],
  )

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: setPointsUserLive,
  })

  return {
    // INCREMENTA sobre o valor que a seat já tinha (oneDetailPeople.points),
    // somando os ganhos desta sessão (points). Antes era `points || inicial`,
    // que ao chegar 1 presente mostrava SÓ o valor do presente (perdia o atual).
    points: (oneDetailPeople?.points ?? 0) + points,
  }
}
